import { useTranslation } from "react-i18next"
import { useCallback } from "react"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { OrderEntity } from "../../Objects/Order/OrderEntity"
import { GetRequest } from "../../services/ApiClientService"

export const useGetServicePointOpenOrders = () => {
  const { t } = useTranslation("general")
  
  const { setError } = useError()

  const handleGetServicePointOpenOrders = useCallback(
    async (servicePointId: number, onSuccess: (orders: OrderEntity[]) => void) => {
    try {
      const response = await GetRequest<OrderEntity[]>(API_ROUTES.ORDER.GET_OPEN_BY_SERVICE_POINT(servicePointId))

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess(response.data?.map((order) => new OrderEntity(order)) ?? [])
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    }
    },
    [setError, t],
  )

  return { handleGetServicePointOpenOrders }
}
